<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cjxjOH/tc-custom/9783968655918.jpg?1703042201847" alt="This image is the cover for the book The Philosophical Theory of the State, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Philosophical Theory of the State, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: " A Greek city-state presented a marked contrast to the modes of human association which prevailed in the non-Greek world. It differed from them above all things by its distinct individuality. No doubt there was a recognisable character in the life and conduct of Egypt or of Assyria, of Phoenicia or of Israel. But the community which has a youth, a maturity, and a decadence, as distinct as those of a single human being, and very nearly as self-conscious; which has a tone and spirit as recognisable in the words and bearing of its members as those of a character in a play; and which expresses its mind in the various regions of human action and endurance much as an artist expresses his individuality in the creations of his genius—such a community had existed, before the beginnings of the modern world, in the Greek city-state, and in the Greek city-state alone. A political consciousness in the strict sense was a necessary factor in the experience of such a commonwealth. The demand for “autonomy”—government by one’s own law,—and for “isonomy”—government according to equal law—though far from being always satisfied, was inherent in the Greek nature; and its strenuousness was evinced by the throes of revolution and the labours of legislation which were shaking the world of Greece at the dawn of history. The very instrument of all political action was invented, so far as we can see, by the Greeks."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bernard Rosanquet
      </h2>
      
      <p class="authorDescription body article">Bernard Bosanquet; (14 June 1848 – 8 February 1923) was an English philosopher and political theorist, and an influential figure on matters of political and social policy in the late 19th and early 20th centuries. His work influenced but was later subject to criticism by many thinkers, notably Bertrand Russell, John Dewey and William James. Bernard was the husband of Helen Bosanquet, the leader of the Charity Organisation Society.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6c57891e